import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-pump',
  templateUrl: './manage-pump.page.html',
  styleUrls: ['./manage-pump.page.scss'],
})
export class ManagePumpPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
